
import axiosApi from '@/request/index'
import Icon from 'vux/src/components/icon/index.vue'

import Scroll from 'vue-slim-better-scroll'
import QuicklyNav from '@/components/quicklyNav'
import HeadNav from '@/components/headNav'
import {getDateTime} from '@/utils/util.js'

export default {
name: "List",
components: {
Icon,
Scroll,
QuicklyNav,
HeadNav
},
computed: {
},
data() {
return {
liveBox: [],
title:'直播列表',
getDateTime:getDateTime
}
},
created() {
this.getLiveList()
},
mounted() {
},
methods: {
getLiveList(){
axiosApi.getliveList().then(res => {
if (res.code == 0) {
var data = res.content
this.liveBox=data.room_info
}
});
}
}

}



// WEBPACK FOOTER //
// ./src/pages/liveList/index.vue